<script lang="ts" setup>
import RangeInput from '@/components/RangeInput.vue';
import { faBath } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useI18n } from 'vue-i18n';
import { useSearchFiltersStore } from '@/views/search/searchFiltersStore.ts';

const { t } = useI18n();

const filters = useSearchFiltersStore();

const minBathrooms = 0;
const maxBathrooms = 6;
const bathroomsStep = 1;
const bathroomsDistance = 1;
</script>

<template>
  <div>
    <div class="mb-2 flex w-full items-center justify-start">
      <FontAwesomeIcon :icon="faBath" class="mr-2 h-4 text-gray-500" />
      {{ t('views.search.bathrooms') }}
    </div>
    <RangeInput v-model:max="filters.bathroomsMax" v-model:min="filters.bathroomsMin" :range-distance="bathroomsDistance" :range-max="maxBathrooms" :range-min="minBathrooms" :range-step="bathroomsStep" :unlimited-label="true" />
  </div>
</template>

<style lang="css" scoped></style>
